import { Week } from '../date/types';

const createDefaultRow = (
  id: number,
  cpt: number,
  cpm: number,
  weekMetaData: Week
) => {
  return {
    id,
    active: true,
    split: {
      isSplit: weekMetaData.isSplit,
      direction: weekMetaData.splitDirection,
      numberOfDays: weekMetaData.numberOfDays
    },
    weekCommencing: weekMetaData.commencingWeek,
    cpt,
    cpm,
    tarps: 0,
    budget: 0,
    impact: 0,
    weekMetaData
  };
};

export default createDefaultRow;
